import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Serve the marketing landing page at the root. Existing /page.html
    // (Delta Modtech personalized video player) remains untouched and is
    // still reachable directly.
    window.location.replace("/landing.html");
  }, []);

  return (
    <div data-testid="redirect-loader" style={{ fontFamily: "Poppins, sans-serif", padding: 24 }}>
      Loading page…
    </div>
  );
}

export default App;
